// extracted by css-extract-rspack-plugin
export default {"cls1":"SocialActionsMenu-cls1_06M","cls2":"SocialActionsMenu-cls2_L2F SocialActionsMenu-cls1_06M"};